import styled, { css } from "styled-components";
import { Pagination as AntdPagination } from "antd";
import PrevIcon from "core/icons/chevron/chevron-left.svg?react";
import FirstIcon from "core/icons/chevron/chevrons-left.svg?react";
import LastIcon from "core/icons/chevron/chevrons-right.svg?react";
import { Breakpoints } from "core/constants";

export const Container = styled.div<{ justifyContent?: string }>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ justifyContent = "flex-start" }) => justifyContent};

  svg {
    width: 24px;
    height: 24px;

    path {
      stroke: ${({ theme }) => theme?.colors?.neutral.neutral80};
    }
  }

  .ant-pagination-disabled {
    path {
      stroke: ${({ theme }) => theme?.colors?.neutral.neutral40};
    }
  }
`;

const hoverStyle = ({ disabled }: any) =>
  !disabled &&
  css`
    &:hover {
      background-color: ${({ theme }) => theme?.colors?.primary.default};

      path {
        stroke: ${({ theme }) => theme?.colors?.white} !important;
      }
    }
  `;

const BaseStyle = styled.a`
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Nunito-Sans;

  ${hoverStyle}
`;

export const BorderedStyle = styled(BaseStyle)<{ disabled: boolean }>`
  border: 1px solid ${({ theme }) => theme?.colors?.neutral.neutral40};
  width: 36px;
  height: 36px;

  path {
    stroke: ${({ disabled, theme }) =>
      disabled ? theme?.colors?.neutral.neutral40 : theme?.colors?.neutral.neutral80} !important;
  }
`;

export const PrevLink = (props: any) => (
  <BorderedStyle {...props}>
    <PrevIcon />
  </BorderedStyle>
);

export const NextLink = (props: any) => (
  <BorderedStyle {...props}>
    <PrevIcon style={{ transform: "rotate(180deg)" }} />
  </BorderedStyle>
);

export const FirstLink = (props: any) => (
  <BorderedStyle {...props}>
    <FirstIcon />
  </BorderedStyle>
);

export const LastLink = (props: any) => (
  <BorderedStyle {...props}>
    <LastIcon />
  </BorderedStyle>
);

export const Pagination = styled(AntdPagination)`
  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-item {
    min-width: 36px !important;
    min-height: 36px !important;

    a {
      line-height: 34px;
      height: 100%;
      width: 100%;
    }
  }

  .ant-pagination-item {
    border-radius: 4px;
    font-family: Nunito-Sans-Bold;
    width: auto;

    a {
      color: ${({ theme }) => theme?.colors?.neutral.neutral80};
    }

    &:focus {
      border-color: #d1d2db;
    }

    &:focus a {
      color: #3b3e66;
    }

    &:hover {
      border: 1px solid #01959f;
      background-color: #01959f;
      box-shadow: 0px 5.008px 11.8px rgba(1, 149, 159, 0.3);
      a {
        color: white;
      }
    }
  }

  .ant-pagination-item-active {
    border: 1px solid ${({ theme }) => theme?.colors?.primary.default};
    background-color: ${({ theme }) => theme?.colors?.primary.default};

    &:focus {
      border-color: ${({ theme }) => theme?.colors?.primary.default};

      a {
        color: ${({ theme }) => theme?.colors?.white};
      }
    }

    a {
      color: ${({ theme }) => theme?.colors?.white};
    }
  }

  margin: 0 8px;
  justify-content: center;
`;
